import _sfc_main from "./BuyBoxFulfillmentTiles2.mjs";
/* empty css                         */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxFulfillmentTiles = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-bcfa70b1"]]);
export {
  BuyBoxFulfillmentTiles as default
};
//# sourceMappingURL=BuyBoxFulfillmentTiles.mjs.map
